import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastProvider } from './providers/ToastProviders.tsx';
import { SocketProvider } from './providers/SocketProvider.tsx';
import router from '@/router/routes.tsx';

const Index = () => {
  const queryClient = new QueryClient();

  const isDevtoolsEnabled =
    import.meta.env.VITE_REACT_QUERY_DEVTOOLS_ENABLED === 'true';

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <SocketProvider>
          <RouterProvider router={router} />
          {isDevtoolsEnabled && <ReactQueryDevtools initialIsOpen={false} />}
        </SocketProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
};

export default Index;
